import React, { useEffect, useState } from "react";
import DModal from "./DModal";
import { Text, View } from "./Themed";
import { TouchableOpacity } from "react-native";
import Global from "../constants/global";
import DIcon from "./DIcon";

const DYear = ({ show, year, change, close, text = "Select year" }) => {
    const [currentYear, setCY] = useState(year)
    const [allYears, setAllYears] = useState([])
    useEffect(() => {
        let y = new Date().getFullYear()
        let limit = 2022
        let ay = []
        for (let cy = limit; cy <= y; cy++) {
            ay.push(cy)
        }
        ay.reverse();

        setAllYears(ay)
    }, [])
    return <DModal
        isVisible={show}
        close={() => close()}>
        <Text variant="headlineMedium">{text}</Text>
        {allYears.map((yr, i) => {
            return <TouchableOpacity id={i + ""} onPress={() => { setCY(yr); change(yr) }}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    {currentYear == yr ? <DIcon name="check" color="green" /> : <View style={{ paddingLeft: 24 }}></View>}
                    <Text style={{ padding: 10 }} variant="headlineSmall">{Global.getYearString(yr)}</Text>
                </View>
            </TouchableOpacity>

        })}
        {/* <TouchableOpacity onPress={() => { setCY(2023); change(2023) }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                {currentYear == 2023 ? <DIcon name="check" color="green" /> : <View style={{ paddingLeft: 24 }}></View>}
                <Text style={{ padding: 10 }} variant="headlineSmall">2023-24</Text>
            </View>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => { setCY(2022); change(2022) }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                {currentYear == 2022 ? <DIcon name="check" color="green" /> : <View style={{ paddingLeft: 24 }}></View>}
                <Text style={{ padding: 10, marginTop: 10 }} variant="headlineSmall">2022-23</Text>
            </View>
        </TouchableOpacity> */}
    </DModal>
}

export default React.memo(DYear)